/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useOnClickOutside } from '../../../../CommonMethods/OutsideClick';
import { Link } from 'react-router-dom';
import FilterDashboard from '../Filter';
import HelpGuideModal from '../../../../components/HelpGuideModal';
import {useGetHelpGuideAdminQuery} from '../../../../features/patientSlice'
import CustomDatePicker from '../../../../components/DatePicker';
import dayjs from 'dayjs';
import moment from 'moment';
import { handleSidebarPrvState } from '../../../../redux/systemConfigSlice';
import GlobalContext from '../../../../components/Context/GloablContext';

const ManageDashboardTopBar = ({
    title,
    path,
    pathPlaceholder,
    SearchInput,
    handleApplyFilter,
    ApplyFilter,
    setFilterValues,
    filterValues,
    initialState,
    setIsChangeStatusOpen,
    username,
    handleCheckBox,
    isPatient,
    handleClearFilter,
    setIsAnyFieldFilled,setdateFilter,dateFilter
}) => {
    
    const [searchParams, setSearchParams] = useSearchParams()
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const outSideClick = useRef();
    const filtervals = useSelector(state => state?.systemConfigData?.filterState);
    const [dateError, setdateError] = useState(false)
    const ref = useRef()
    const dispatch = useDispatch();
    const {setIsAdvancedSearchOpen,isSideBar,setIsSideBar} = useContext(GlobalContext);

    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    useOnClickOutside(ref, () => {
        setIsChangeStatusOpen(false)
    })

    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
    useEffect(() => {
        if (userType === 'corporate-user') {
            setQueryParamsadmin('type=corporate-dashboard-list-alerts');
        } else {
            setQueryParamsadmin('type=corporate-dashboard-list-alerts');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);

    const handleCheck=(start_date,end_date)=>{
        if((dayjs(end_date).isBefore(dayjs(start_date)))&&(end_date!==undefined&&start_date!==undefined)){
            return true
        }
        return false
    }

    function handleSelectDate(id,date,dateString,termkey){
        isFilterOpen&&setIsFilterOpen(false)
        if(id==="filter_end_date"&&dateFilter?.filter_start_date!==undefined&&handleCheck(dateFilter?.filter_start_date,dateString)){
            setdateError(true)
            return
        }
        if(id==="filter_start_date"&&dateFilter?.filter_end_date!==undefined&&handleCheck(dateString,dateFilter?.filter_end_date)){
            setdateError(true)
            return
        }
        setdateError(false)
        let params = Object.fromEntries(searchParams)
        params.page_number = 1
        params.last_page = null
        params.last_id = null
        params.last_sort_value = null

        if(id==="filter_start_date"){
            setdateFilter((prv) => ({
                ...prv,
                filter_start_date: dateString,
            }));
                
            params.start_date =moment(dateString).format('YYYY-MM-DD')
            setSearchParams({...params})
                
        }
        else{
            setdateFilter((prv) => ({
                ...prv,
                filter_end_date: dateString,
            }));
            params.end_date= moment(dateString).format('YYYY-MM-DD')
            setSearchParams({...params})
        }
            
    }
    
    const handleOpenFilter = () => {
     
        // Check for reading_type, alert_type, filter_start_date, and filter_end_date
        if ((searchParams.get("reading_type") !== null || searchParams.get("alert_type") !== null) && !isFilterOpen) {
            setFilterValues((prevFilterValues) => ({
                ...prevFilterValues,
                ...filtervals,
                reading_type: searchParams.get("reading_type")?.split(',') || [],
                alert_type: searchParams.get("alert_type")?.split(',') || [],
            }));
            
        } else if (searchParams.get("reading_type") === null && searchParams.get("alert_type") === null) {
            setFilterValues({
                'reading_type': [],
                'alert_type': [],
            });
        }
    
        setIsFilterOpen(!isFilterOpen);
    };

    // Function to handle onClick logic
    const handleSearchClick = () => {  
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));

        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };
    
    return (
        <div className="flex justify-between items-center">
            <div className='flex items-center mb-[14px] min-w-fit mr-2.5'>
                {title !== undefined ?
                    <h1 className={`text-xl font-normal text-[#000000] 2xl:self-center 2xl:pt-0 pt-2 self-start ${isPatient===undefined?'min-w-fit':'xl:min-w-fit'}`}>{title}</h1>
                    :
                    pathPlaceholder &&
                    <Link to={path} state={username && path !== '/manage-admin-corporate/' ? [username] : null} className='hidden items-center min-w-max xl:flex'>
                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                        <span className='text-sm font-normal text-[#008586] ml-3'>{pathPlaceholder}</span>
                    </Link>
                }
                {
                    userType !=='super-admin' &&
                    <span   onClick={() => setHelpGuideModel(true)} className='ml-2 min-w-fit cursor-pointer xl:z-0 z-[999]'>
                        <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                    </span> 
                }

            </div>
         
            <div className="flex items-start w-fit justify-end relative">
                <div className='relative flex items-center'>
                    <div className='w-fit'>
                        <CustomDatePicker 
                            id={"filter_start_date"}
                            classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                            format="MMM DD, YYYY"
                            state={dateFilter}
                            placeholder={"Select start date"}
                            label={""} 
                            termkey={dateFilter.filter_start_date}
                            handleSelect={handleSelectDate}
                            imageClass={true}
                            setdateError={setdateError}
                            disabledFutureDate={false}
                        />
                    </div>
                
                    <div className='w-fit ml-2.5'>
                        <CustomDatePicker 
                            label={""} 
                            classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                            placeholder={"Select end date"}
                            format="MMM DD, YYYY"
                            state={dateFilter}
                            termkey={dateFilter.filter_end_date}
                            handleSelect={handleSelectDate}
                            id={"filter_end_date"}
                            setdateError={setdateError}
                            disabledFutureDate={false}
                        />
                    </div>
                    {dateError && <span className='text-xs text-red-500 absolute top-11 left-0'>Please select the valid date range.</span>}
                </div>
                <button type='button' id="search-btn" className='w-[52px] min-w-[50px] h-[46px] border border-[#972E4C] rounded-[16px] outline-0 cursor-pointer ml-2.5 flex justify-center items-center' 
                    onClick={()=> handleSearchClick()}>   
                    <img loading="lazy" decoding="async" src="/images/search_red.svg" alt="icon"  className='w-5 h-5'/>
                </button>
                <FilterDashboard
                    dateError={dateError}
                    setdateError={setdateError}
                    isFilterOpen={isFilterOpen}
                    setIsFilterOpen={setIsFilterOpen}
                    handleApplyFilter={handleApplyFilter}
                    filterValues={filterValues}
                    setFilterValues={setFilterValues}
                    initialState={initialState}
                    setIsAnyFieldFilled={setIsAnyFieldFilled}
                    handleClearFilter={handleClearFilter}
                    handleCheckBox={handleCheckBox}
                    isPatient={isPatient}
                    handleOpenFilter={handleOpenFilter} 
                />
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
            </div>
        </div>
    );
}

export default ManageDashboardTopBar;
